(function () {
  console.log("🛒 Cart reload script loaded");

  let reloadTimeout;

  function triggerReload() {
    clearTimeout(reloadTimeout);

    reloadTimeout = setTimeout(function () {
      console.log("🔄 Cart updated — reloading page");
      window.location.reload();
    }, 700); // wait for AJAX cart update to finish
  }

  // + / - buttons and remove button
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".quantity-plus") ||
      e.target.closest(".quantity-minus") ||
      e.target.closest(".cart-items__remove")
    ) {
      triggerReload();
    }
  });

  // Manual quantity input change
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="updates[]"]')) {
      triggerReload();
    }
  });

})();
